module.exports = __webpack_public_path__ + "static/16th-ff55ecd4ad65149cb8da01797fc82b77.png";